import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";

const Newsletter = () => {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setBusy(true);
    try {
      const { data } = await api.post("/subscribe", { email });
      toast.success(data.already ? "Already subscribed" : "Subscribed", { description: data.message });
      if (!data.already) setEmail("");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Could not subscribe");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="newsletter" className="border border-white/15 p-6">
      <div className="overline-label text-signal mb-2">// Join the Transmission</div>
      <h3 className="font-display text-xl font-bold text-masthead-ink mb-2">Join the Dispatch List</h3>
      <p className="font-body text-sm text-masthead-ink/60 mb-4">
        Subscribe to the archive and get a welcome transmission in your inbox.
      </p>
      <form onSubmit={submit} className="flex flex-col sm:flex-row gap-2">
        <input
          data-testid="newsletter-email"
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="your@email.com"
          className="flex-1 bg-transparent border border-white/20 px-4 py-3 font-mono2 text-sm text-masthead-ink placeholder:text-masthead-ink/40 focus:outline-none focus:border-signal"
        />
        <button
          data-testid="newsletter-submit"
          type="submit"
          disabled={busy}
          className="bg-signal text-white font-mono2 text-xs uppercase tracking-[0.2em] px-6 py-3 hover:opacity-90 disabled:opacity-50 whitespace-nowrap"
        >
          {busy ? "…" : "Subscribe"}
        </button>
      </form>
    </div>
  );
};

export const Footer = () => (
  <footer className="bg-masthead text-masthead-ink mt-24">
    <div className="max-w-[1400px] mx-auto px-4 sm:px-8 lg:px-16 py-16">
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-10 mb-12">
        <div className="lg:col-span-1">
          <h2 className="font-display font-black text-2xl tracking-tight">DISCLOSURE JOURNAL</h2>
          <p className="font-body italic text-masthead-ink/70 text-sm mt-1">They're here. Keep up.</p>
          <p className="font-body text-masthead-ink/60 mt-3">
            An independent editorial archive curating the most credible reporting, testimony and documentary evidence on UAP, UFO, NHI and the global push for full disclosure. We link — we do not publish original claims.
          </p>
          <div className="mt-6 flex gap-8">
            <div>
              <div className="overline-label text-signal mb-3">Sections</div>
              <ul className="space-y-2 font-grotesk text-sm text-masthead-ink/80">
                <li><Link to="/" className="hover:text-signal">The Feed</Link></li>
                <li><Link to="/store" className="hover:text-signal">The Store</Link></li>
                <li><Link to="/login" className="hover:text-signal">Editor Access</Link></li>
              </ul>
            </div>
          </div>
        </div>
        <div className="lg:col-span-2">
          <Newsletter />
          <p className="font-mono2 text-[0.65rem] leading-relaxed tracking-wider text-masthead-ink/40 uppercase mt-6">
            All articles and videos link to third-party sources. DisclosureJournal does not host or produce original reporting. We never ask for passwords or payment details by email.
          </p>
        </div>
      </div>
      <div className="border-t border-white/10 pt-6 flex flex-col sm:flex-row justify-between gap-2">
        <span className="font-mono2 text-[0.65rem] tracking-[0.2em] text-masthead-ink/40 uppercase">© 2026 DisclosureJournal — Curated Archive</span>
        <span className="font-mono2 text-[0.65rem] tracking-[0.2em] text-masthead-ink/40 uppercase">The Truth Is Linked</span>
      </div>
    </div>
  </footer>
);
